// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"_2skdE_jr1k6mLH_CLPiQNU","bodyText":"_2YHRE2JagQ5rq_bYZtlQoQ","logoWrapper":"_2UyQNDm0KMSoLpngKAwrMV"};